import React from "react";

interface FilterIconProps extends React.SVGProps<SVGSVGElement> {
  strokeColor?: string; // optional prop to override
}

const FilterIcon: React.FC<FilterIconProps> = ({ strokeColor, ...props }) => {
  return (
    // <svg
    //   {...props}
    //   width="20"
    //   height="20"
    //   viewBox="0 0 20 20"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    //   stroke={strokeColor || "rgb(var(--primary-color))"} // use CSS var
    // >
    //   <path
    //     d="M18.3334 2.5H1.66675L8.33341 10.3833V15.8333L11.6667 17.5V10.3833L18.3334 2.5Z"
    //     strokeWidth="1.5"
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    // </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-list-filter-icon lucide-list-filter"
      stroke={strokeColor || "rgb(var(--primary-color))"}
      {...props}
    >
      <path d="M2 5h20" />
      <path d="M6 12h12" />
      <path d="M9 19h6" />
    </svg>
  );
};

export default FilterIcon;
